export type GraphicsManifest = Record<string, string[]>;

let manifestPromise: Promise<GraphicsManifest> | null = null;

/**
 * Loads sticker/graphics URLs from public/graphics/manifest.json (generated by
 * scripts/extract-graphics-to-public.mjs). Cached for the session.
 */
export function loadGraphicsManifest(): Promise<GraphicsManifest> {
  if (!manifestPromise) {
    const base = process.env.PUBLIC_URL || '';
    manifestPromise = fetch(`${base}/graphics/manifest.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load graphics manifest (${response.status})`);
        }
        return response.json() as Promise<GraphicsManifest>;
      })
      .catch((error) => {
        manifestPromise = null;
        throw error;
      });
  }
  return manifestPromise;
}

export function flattenGraphicsManifest(
  manifest: GraphicsManifest,
  activeCategory: string,
): { key: string; src: string; alt: string }[] {
  if (activeCategory === 'All') {
    return Object.entries(manifest).flatMap(([category, urls]) =>
      urls.map((src, index) => ({
        key: `${category}-${index}`,
        src,
        alt: `${category} graphic`,
      })),
    );
  }

  return (manifest[activeCategory] || []).map((src, index) => ({
    key: `${activeCategory}-${index}`,
    src,
    alt: `${activeCategory} graphic`,
  }));
}
